import script from "./EditOrganization.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditOrganization.vue?vue&type=script&setup=true&lang=ts"

import "./EditOrganization.vue?vue&type=style&index=0&id=3123e204&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3123e204"]])

export default __exports__